import { render, staticRenderFns } from "./KgMenu.vue?vue&type=template&id=3a4c0b0f&scoped=true"
import script from "./KgMenu.vue?vue&type=script&lang=js"
export * from "./KgMenu.vue?vue&type=script&lang=js"
import style0 from "./KgMenu.vue?vue&type=style&index=0&id=3a4c0b0f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c0b0f",
  null
  
)

export default component.exports